import { Component } from "react";
import * as React from "react";
import { FocusTrap } from "../../../sharedHOC/adjustContainer/FocusTrap";
import { ClickOutside, CloseCallback } from "../../../sharedHOC/ClickOutside/ClickOutside";
import { AnnotationContentContainer } from "../containers/AnnotationContentContainer";
import { getCoordStylesPositions } from "../helper/getAnnotationCoord";
import { AnnotationItemExtended } from "../types";
import * as styles from "./ImageAnnotations.less";
import { AnnotationContentProps, AnnotationContentTheme } from "./ImageAnnotationsContent";

interface Props extends Partial<AnnotationContentProps> {
    handleClickOutside: CloseCallback;
    annotationContainerRef: React.RefObject<HTMLElement>;
    annotation: AnnotationItemExtended;
}

export class ImageAnnotationView extends Component<Props> {
    annotationMenuRef: React.RefObject<HTMLElement> = React.createRef();
    constructor(props: Props) {
        super(props);

        this.setMenuRef = this.setMenuRef.bind(this);
    }
    setMenuRef(el: React.RefObject<HTMLElement>) {
        // @ts-ignore
        this.annotationMenuRef.current = el.current;
    }
    render() {
        return (
            <ClickOutside
                closeActionHandler={this.props.handleClickOutside}
                containerElRef={this.props.annotationContainerRef}
                triggerElRef={this.annotationMenuRef}
            >
                <FocusTrap autoFocus={true} enforceFocus={true}>
                    <div
                        className={styles.editor_content}
                        style={getCoordStylesPositions(this.props.annotation.geometry)}
                    >
                        <AnnotationContentContainer
                            annotation={this.props.annotation}
                            theme={[AnnotationContentTheme.dark, AnnotationContentTheme.inner_tooltip]}
                            onChange={this.props.onChange}
                            onSubmit={this.props.onSubmit}
                            startEdit={this.props.startEdit}
                            menuRefCallback={this.setMenuRef}
                        />
                    </div>
                </FocusTrap>
            </ClickOutside>
        );
    }
}
